import classNames from 'classnames';
import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';

export interface ICraRiskScoreDotProps extends ITranslateProps {
    value?: number | null;
}

class CraRiskScoreDotComponent extends React.Component<ICraRiskScoreDotProps, Record<string, unknown>> {
    public override render() {
        const score = this.props.value && isFinite(this.props.value) ? this.props.value : 0;

        const text = this.props.t(`cra.riskScore${score}`);
        const classObject = {
            fa: true,
            'fa-square': score !== 0,
            'fa-square-o': score === 0,
            active: score === 0,
            fs16: true,
            ml20: true,
            [`icon-crariskscore-${score}`]: true,
        };
        return <span className={classNames(classObject)} title={text}></span>;
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CraRiskScoreDot = translate()(CraRiskScoreDotComponent);
